
  export default {
    props: ['error'],
    layout: 'error', // you can set a custom layout for the error page
    beforeMount(){
       //location.href="/";
       console.log(this.error)
    },
  }
